import React, { Component } from 'react';
import moment from 'moment';
import get from 'lodash/get';
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import size from 'lodash/size';
import ceil from 'lodash/ceil';
import If from '../../../components/Shared/If';
import { deepClone } from '../../../utils/copyObject';
import { calculateIndexRange } from '../../../utils/dashboardUtils';
import Paginations from '../../../components/Pagination/Pagination';
import { sortArray, sortDatesArray, sortNumbersArray, sortByNumbers } from '../../../components/Shared/ReusablesUtils';
import PropTypes from 'prop-types';
import '../Analytics.css';
import NoDataFound from '../../../assets/no-kpidata-range.png';

const NoRecord = "No record found";
class ToolsGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            adminSortOrder: 'asc',
            gridPagination: {
                defaultRecord: 10,
                currentPage: 1,
                recordCount: 10
            },
            toolsAnalytics: this.props.toolsAnalytics && size(this.props.toolsAnalytics.length) > 0 ? deepClone(this.props.toolsAnalytics) : [],
            searchKey: this.props.searchObject && !isEmpty(this.props.searchObject.toolname) ? get(this.props.searchObject, 'toolname', '') : ''
        }
    }

    componentWillReceiveProps(nextProps) {
        let { searchKey } = this.state;
        if (nextProps.searchObject.toolname !== searchKey) {
            this.setState({
                gridPagination: {
                    ...this.state.gridPagination,
                    currentPage: 1,
                    defaultRecord: 10,
                    recordCount: 10
                }
            });
        }
        this.setState({
            toolsAnalytics: nextProps.toolsAnalytics.map((eachTool) => {
                return { ...eachTool, createdBy: this.getCreatedByName(eachTool.createdBy), noOfShares: this.getNumberOfShare(eachTool) }
            })
        });
    }

    getCreatedByName = (item) => {
        if (!isEmpty(item.firstName) && !isEmpty(item.lastName) && item.firstName !== undefined && item.lastName !== undefined) {
            return `${item.firstName} ${item.lastName}`
        }
        return 'NA';
    }

    renderList = (list) => {
        if (list && list.length > 0) {
            return list.map((item, index) => (
                <tr key={index}>
                    <td>{item.name}</td>
                    <td>{moment(item.createdDate).format('MM/DD/YYYY')}</td>
                    <td>{has(item, 'createdBy') ? item.createdBy : 'NA'}</td>
                    <td>{!isEmpty(item.category) ? item.category : 'NA'}</td>
                    <td>{!isEmpty(item.subCategory) ? item.subCategory : 'NA'}</td>
                    {/* <td>{item.noOfShares ? item.noOfShares : 0}</td> */}
                    {has(item, 'metrics') ? this.getKeyValue(item) : 0}
                </tr>
            ));
        }
        return <tr><td>{NoRecord}</td></tr>;
    };

    getKeyValue = (object) => {
        const rowsArray = [];
        for (const [index, [key, value]] of Object.entries(Object.entries(object.metrics))) {
            rowsArray.push(<td key={key}>{object.metrics[key] instanceof Array && typeof object.metrics[key] !== undefined ? object.metrics[key].length : 0}</td>);
        }
        return rowsArray;
    };


    sortToolName = (key) => {
        let adminSortOrder;
        if (this.state.adminSortOrder === 'asc') {
            adminSortOrder = 'desc';
        } else {
            adminSortOrder = 'asc';
        }

        let sortedKeysResult = this.props.toolsAnalytics.map((eachTool) => {
            return { ...eachTool, createdBy: this.getCreatedByName(eachTool.createdBy), noOfShares: this.getNumberOfShare(eachTool) }
        });

        this.setState({ adminSortOrder }, () => {
            let updatedList = sortArray(sortedKeysResult, key, this.state.adminSortOrder);
            this.setState({
                toolsAnalytics: updatedList
            });
        });
    }

    getNumberOfShare = (eachTool) => {
        return eachTool.metrics && eachTool.metrics.noOfShares ? eachTool.metrics.noOfShares.length : 0
    }
    sortDates = (key) => {
        let adminSortOrder;
        if (this.state.adminSortOrder === 'asc') {
            adminSortOrder = 'desc';
        } else {
            adminSortOrder = 'asc';
        }

        let sortedKeysResult = this.props.toolsAnalytics.map((eachTool) => {
            return { ...eachTool, createdBy: this.getCreatedByName(eachTool.createdBy), noOfShares: this.getNumberOfShare(eachTool) }
        });

        this.setState({ adminSortOrder }, () => {
            let updatedList = sortDatesArray(sortedKeysResult, key, this.state.adminSortOrder);
            this.setState({
                toolsAnalytics: updatedList
            });
        });
    }

    sortDynamicFields = (key) => {
        let adminSortOrder;
        if (this.state.adminSortOrder === 'asc') {
            adminSortOrder = 'desc';
        } else {
            adminSortOrder = 'asc';
        }

        let sortedKeysResult = this.props.toolsAnalytics.map((eachTool) => {
            return { ...eachTool, createdBy: this.getCreatedByName(eachTool.createdBy), noOfShares: this.getNumberOfShare(eachTool) }
        });

        this.setState({ adminSortOrder }, () => {
            let updatedList = sortByNumbers(sortedKeysResult, key, this.state.adminSortOrder);
            this.setState({
                toolsAnalytics: updatedList
            });
        });
    }

    handlePageNavigation = (nextOrPrevious) => {
        if (nextOrPrevious === 'previous' || nextOrPrevious === 'next') {
            this.setState(
                {
                    gridPagination: {
                        ...this.state.gridPagination,
                        currentPage: nextOrPrevious === 'previous' ? parseInt(this.state.gridPagination.currentPage - 1) : parseInt(this.state.gridPagination.currentPage + 1)
                    }
                }
            );
        } else {
            this.setState(
                {
                    gridPagination: {
                        ...this.state.gridPagination,
                        currentPage: parseInt(nextOrPrevious)
                    }
                }
            );
        }

    }

    handleRecordCountChange = (event) => {
        let { value } = event.target;
        let { gridPagination: { recordCount } } = this.state;
        this.setState({ gridPagination: { ...this.state.gridPagination, recordCount: parseInt(value), totalPage: ceil(size(this.state.userAnalytics) / recordCount) } });
    }

    generatePageNumbers = (userAnalytics) => {
        let { currentPage, recordCount } = this.state.gridPagination;
        let pageNumbers = [];

        if (recordCount > size(userAnalytics)) {
            pageNumbers = [];
        } else {
            for (let i = 1; i <= Math.ceil(size(userAnalytics) / recordCount); i++) {
                pageNumbers.push(<li key={i} className="page-item"><span className={currentPage === i ? 'page-link currentpage-active' : 'page-link'} onClick={() => this.handlePageNavigation(i)}>{i}</span></li>)
            }
        }
        // Slice only 1 to 10 Page
        let pageNumbersInitial = pageNumbers.slice(0, 10);
        return pageNumbersInitial;
    }

    render() {

        // Tools Tab Pagination

        let { toolsAnalytics } = this.state;
        let { gridPagination: { currentPage, recordCount, totalPage } } = this.state;
        let test = calculateIndexRange(currentPage, recordCount);
        const slicedRecords = toolsAnalytics.slice(test.begin, test.end);
        let totalPageNumber = Math.ceil(size(toolsAnalytics) / recordCount);
        let nodataFound = null;
        if(toolsAnalytics && toolsAnalytics.length === 0) {
          nodataFound = (<div className="text-center no-data-available-desc">
            <p style={{marginBottom: '0px'}}>Looks like there's no data available for the parameters you selected.</p>
            <p> Try adjusting your filters, dates.</p>
            <img src={NoDataFound} className="no-kpi-date-range"/>
          </div>)
        }

        return (
            <div>
                { toolsAnalytics.length > 0 && (
                <div>
                <div className="row p-0 m-0 mt-3 mb-2 table-responsive-sm table-ellipsis">
                    <table className="toolkit-list table text-primary-color tool-list-font borderTop0">
                        <thead>
                            <tr className="col-sm-4 mb-3">
                                <th scope="col" className='bottom-border-color borderTop0' ><span className="table-sort-title">Tool Name</span><span onClick={() => this.sortToolName('name')} className="table-sort-icon pull-right fa fa-sort"></span></th>
                                <th scope="col" className='bottom-border-color borderTop0'><span className="table-sort-title">Date Created</span><span onClick={() => this.sortDates('createDate')} className="table-sort-icon pull-right fa fa-sort"></span></th>
                                <th scope="col" className='bottom-border-color borderTop0'><span className="table-sort-title">Created By</span><span onClick={() => this.sortToolName('createdBy')} className="table-sort-icon pull-right fa fa-sort"></span></th>
                                <th scope="col" className='bottom-border-color borderTop0'><span className="table-sort-title">Category</span><span onClick={() => this.sortToolName('category')} className="table-sort-icon pull-right fa fa-sort"></span></th>
                                <th scope="col" className='bottom-border-color borderTop0'><span className="table-sort-title">Subcategory</span><span onClick={() => this.sortToolName('subCategory')} className="table-sort-icon pull-right fa fa-sort"></span></th>
                                <th scope="col" className='bottom-border-color borderTop0'><span className="table-sort-title">Number Of Shares</span><span onClick={() => this.sortDynamicFields('noOfShares')} className="table-sort-icon pull-right fa fa-sort"></span></th>
                               
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderList(slicedRecords)}
                        </tbody>
                    </table>
                </div>
                <If condition={size(toolsAnalytics) > 0}>
                    <Paginations
                        currentPage={currentPage}
                        totalPageNumber={totalPageNumber}
                        handlePageNavigation={this.handlePageNavigation}
                        Analytics={toolsAnalytics}
                        generatePageNumbers={this.generatePageNumbers}
                        handleRecordCountChange={this.handleRecordCountChange}
                        recordCount={recordCount}
                        totalRecords={size(toolsAnalytics)}
                    />
                </If>
                </div>
                )}
                {nodataFound}
            </div>
        )
    }
}

ToolsGrid.propTypes = {
    toolsAnalytics : PropTypes.array
}


export default ToolsGrid;